import { LogicalSpace } from '@thive/fddm-types';
import { useMemo } from 'react';

import { useAppStore } from '@modules/app/store/useAppStore';
import { useFloorplanDesignStore } from '../store/useFloorplanDesignStore';

export const useReadSelectedLogicalSpaces = (): LogicalSpace[] => {
  const ids = useAppStore((state) => state.selectedIds);
  const allLogicalSpaces = useFloorplanDesignStore((state) => state.design.logicalSpaces);

  const selectedIds = useMemo(() => new Set(ids), [ids]);

  return useMemo(
    () => allLogicalSpaces.filter((space) => selectedIds.has(space.id)),
    [allLogicalSpaces, selectedIds],
  );
};
